(() => {
  const addStyle = (root, css) => {
    if (!root || root.querySelector('[data-off-mobile-style]')) return;
    const style = document.createElement('style');
    style.dataset.offMobileStyle = '';
    style.textContent = css;
    root.append(style);
  };
  let attempts = 0;
  const enhanceWidgets = () => {
    const withdrawal = document.querySelector('.widerruf-popup-source--embed');
    const footer = document.querySelector('footer a[href="/policies/refund-policy"]')?.closest('.footer-block');
    const withdrawalRoot = withdrawal?.shadowRoot;
    const trigger = withdrawalRoot?.querySelector('[data-widerruf-popup-open]');
    let withdrawalReady = false;
    if (trigger && footer) {
      if (!footer.contains(withdrawal)) footer.append(withdrawal);
      addStyle(withdrawalRoot, `@media(max-width:749px){
        .widerruf-trigger-button--floating{
          position:static!important;inset:auto!important;transform:none!important;
          display:inline-flex!important;align-items:center;min-height:44px!important;
          padding:10px 0!important;margin:0!important;border:0!important;border-radius:0!important;
          background:transparent!important;background-color:transparent!important;
          color:#fff!important;-webkit-text-fill-color:#fff!important;box-shadow:none!important;
          font:14px/1.5 Helvetica,Arial,sans-serif!important;text-decoration:underline;text-underline-offset:4px
        }
        .widerruf-trigger-button--floating:focus-visible{outline:2px solid #fff;outline-offset:3px}
      }`);
      withdrawalReady = true;
    }
    const chatRoot = document.querySelector('shopify-chat')?.shadowRoot?.querySelector('shopify-agent-runtime')?.shadowRoot;
    const activator = chatRoot?.querySelector('.activator');
    if (activator) {
      addStyle(chatRoot, `@media(max-width:749px){
        .activator-nudge{right:12px!important;bottom:calc(12px + env(safe-area-inset-bottom))!important}
        .activator{width:48px!important;min-width:48px!important;height:48px!important;min-height:48px!important;padding:12px!important;border-radius:50%!important;gap:0!important}
        .activator__label{display:none!important}
        .activator__icon{width:24px!important;height:24px!important}
      }`);
    }
    attempts += 1;
    if ((!withdrawalReady || !activator) && attempts < 60) setTimeout(enhanceWidgets, 500);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhanceWidgets, {once:true});
  else enhanceWidgets();
  document.addEventListener('shopify:section:load', () => {attempts=0;enhanceWidgets();});
})();
